import {
  ClientLogClient,
  ClientLogRequest,
  LogLevel,
} from 'src/WebApiController';

import { REACT_APP_NAME } from './constants/constants';

export const logToServer = (
  logLevel: LogLevel,
  errorId: string,
  errorMessage: string,
  additionalInfo: object,
  logEvent?: (logRequest: ClientLogRequest) => void
) => {
  const entry = {
    logLevel: logLevel,
    applicationSource: REACT_APP_NAME,
    errorId: errorId,
    error: errorMessage,
    pageUrl: window.location.href,
    componentStack: '',
    additionalInfo: additionalInfo,
    timestamp: new Date().toISOString(),
  };

  if (logEvent) {
    logEvent(entry);
  } else {
    const clientLog = new ClientLogClient({});
    clientLog.logEvents([entry]);
  }
};
